import { actions as FormErrorActions } from 'app/containers/Dashboard/FormError/slice';
import flatten from 'flat';
import { validateYupSchema, yupToFormErrors } from 'formik';
import { ObjectSchema } from 'yup';

export async function validateForm(values, schema, dispatch, context?) {
  try {
    await validateYupSchema(values, schema, true, context);
  } catch (err: any) {
    const labelsMap: Map<string, string> = new Map();
    err?.inner?.forEach?.(error => {
      // the flatten function below transforms the array index to dot notation (someprop.0), however the path contains the array index in []-braces (someprop[0])
      labelsMap.set(error?.path?.replace?.('[', '.')?.replace?.(']', ''), error?.params?.label);
    });
    const errors: { [key: string]: string | undefined } = yupToFormErrors(err);
    const flattenObject: {} = flatten(errors);
    let formErrors = Object.keys(flattenObject).map(
      key => `${labelsMap.get(key) ?? key}: ${flattenObject[key]}`
    );
    dispatch(FormErrorActions.error(Object.values(flatten(formErrors))));
    return errors;
  }
  dispatch(FormErrorActions.close());
  return {};
}

export async function validateField(fieldName: string, value, schema: ObjectSchema<any>) {
  try {
    await schema.validateAt(fieldName, { [fieldName]: value });
  } catch (err: any) {
    return yupToFormErrors(err)?.[fieldName];
  }
  return undefined;
}
